
// import axios from "axios";
import { HOST_API_KEY } from '../config-global';
import axios from '../utils/axios';


// function myHeaders(){
//     console.log(localStorage.getItem('accessToken'), "MY HEADER")
//     return { Authorization: `Bearer ${localStorage.getItem('accessToken')}` };
// }


const Api = axios.create({
    // baseURL: 'http://localhost:3009/api'
    baseURL: `${HOST_API_KEY}mgmt`,

});



// PDF
export const getContract = async() => {

    const response = await Api.get('/contract', {
          responseType: 'blob', 
        });
    return response.data
}

export const getSysInfo = async(id) => {
    const response = await Api.get(`info/${id}`)
    return response.data
}
export default Api;